export const gloriafood = {
  seo: {
    title: 'Gloriafood ferme ? Passez gratuitement à Bistroo',
    description:
      "Gloriafood cesse ses services le 30 avril 2027. Passez à Bistroo dès maintenant : gratuit jusqu'au 1er mai 2027 et votre boutique en ligne en moins de 30 minutes.",
  },
  hero: {
    badge: 'Important pour les restaurants Gloriafood',
    title_1: 'Gloriafood ferme ses portes.',
    title_em: 'Votre nouvelle maison est prête.',
    subtitle:
      "Gloriafood cesse tous ses services le 30 avril 2027. Des milliers de restaurants auront alors besoin d'une nouvelle solution de commande. Bistroo est prêt pour vous, et jusque-là vous ne payez rien.",
    offer_pt1: "Abonnement gratuit jusqu'au",
    offer_date: '30 avril 2027',
    offer_pt2: " inclus, le jour où Gloriafood s'arrête.",
    cta_primary: 'Créer ma boutique, gratuitement',
    cta_secondary: 'Parler à notre équipe',
    reassurance: 'Pas de carte de crédit. En ligne en moins de 30 minutes. Résiliable chaque mois.',
  },
  countdown: {
    label: 'Temps restant avant la fermeture de Gloriafood',
    units: {
      months: 'mois',
      days: 'jours',
      hours: 'heures',
      minutes: 'minutes',
    },
    cta_text: "Chaque jour d'attente vous rapproche d'une boutique qui passe hors ligne.",
    cta_link: "Passez dès aujourd'hui",
  },
  trust: {
    items: [
      { icon: 'bi-lightning-charge-fill', text: 'En ligne en moins de 30 minutes' },
      { icon: 'bi-credit-card-2-front-fill', text: "Sans frais d'installation" },
      { icon: 'bi-unlock-fill', text: 'Sans engagement à long terme' },
      { icon: 'bi-headset', text: 'Aide personnelle pour votre migration' },
    ],
  },
  timeline: {
    kicker: 'Ce qui se passe',
    heading: 'Le compte à rebours a commencé pour les restaurants Gloriafood',
    lead: "Voici ce qu'il faut savoir, et ce qu'il vaut mieux faire maintenant.",
    items: [
      {
        icon: 'bi-megaphone-fill',
        date: 'Maintenant',
        title: 'Gloriafood annonce son arrêt',
        text: 'Gloriafood a annoncé la fin de tous ses services. Des milliers de restaurants doivent donc chercher une nouvelle solution de commande en ligne.',
      },
      {
        icon: 'bi-exclamation-triangle-fill',
        date: '30 avril 2027',
        title: "Les serveurs de Gloriafood s'éteignent",
        text: 'Toutes les boutiques, sites web et pages de commande qui tournent sur Gloriafood cessent de fonctionner. Plus de commandes, plus de revenus.',
      },
      {
        icon: 'bi-check-circle-fill',
        date: "Aujourd'hui",
        title: 'Passez à Bistroo sans frais',
        text: "Inscrivez-vous maintenant et utilisez votre boutique Bistroo complète gratuitement jusqu'au 30 avril 2027. Vous migrez à votre rythme, sans précipitation et sans payer deux fois.",
      },
    ],
  },
  why: {
    kicker: 'Le bon choix',
    heading: "Pourquoi Bistroo est l'alternative logique",
    lead: 'Pas un outil de boutique en ligne de plus. Bistroo est conçu de A à Z pour des restaurants comme le vôtre.',
    items: [
      {
        title: 'Votre boutique est entièrement à vous',
        text: "Votre marque, votre domaine, les données de vos clients. Aucune place de marché ne s'interpose entre vous et vos clients : commandes, revenus et relations restent chez vous.",
      },
      {
        title: "Un design nouvelle génération, prêt à l'emploi",
        text: "Les boutiques Bistroo ont un look vraiment moderne. Avec des modèles personnalisables, votre boutique met en valeur la qualité de votre cuisine, au lieu d'une page de commande générique de 2015.",
      },
      {
        title: 'Une suite complète à un prix accessible',
        text: 'Boutique, site web, commande par QR, kiosque et caisse font partie du même écosystème. Un abonnement mensuel, des tarifs transparents, tout se gère dans le Bistroo Manager.',
      },
      {
        title: 'Un partenaire, pas un fournisseur',
        text: "Bistroo est résiliable chaque mois, parce que nous voulons mériter votre confiance mois après mois. Pas d'engagement forcé et pas de surprises.",
      },
    ],
  },
  features: {
    kicker: 'Pourquoi Bistroo',
    heading: 'Tout ce que vous aviez chez Gloriafood, et plus encore',
    lead: "Conçu pour la restauration rapide, la vente à emporter et la livraison. Pas un ajout secondaire, mais précisément la raison d'être de notre logiciel.",
    items: [
      {
        icon: 'bi-shop',
        title: 'Une boutique à votre image',
        text: 'Votre propre domaine, vos couleurs et des modèles personnalisables. Vos clients commandent directement chez vous, pas via une place de marché.',
      },
      {
        icon: 'bi-phone',
        title: 'Gestion complète des commandes',
        text: 'Acceptez, gérez et suivez chaque commande en temps réel dans le Bistroo Manager. Menus, horaires et prix se modifient vous-même, immédiatement.',
      },
      {
        icon: 'bi-cash-coin',
        title: 'Des tarifs transparents et équitables',
        text: 'Un abonnement mensuel sans surprises. Vous savez toujours à quoi vous en tenir et les données de vos clients restent les vôtres.',
      },
      {
        icon: 'bi-lightning-charge',
        title: 'En libre-service, plug & play',
        text: 'Pas besoin de développeur. Créez votre menu, connectez vos versements via Stripe et mettez en ligne, le tout en moins de 30 minutes.',
      },
      {
        icon: 'bi-globe-europe-africa',
        title: "Une croissance à travers l'Europe",
        text: 'Actif aux Pays-Bas et en Belgique, et en Allemagne plus tard en 2026. Conçu pour évoluer avec vos ambitions.',
      },
      {
        icon: 'bi-headset',
        title: 'Un service client personnel',
        text: "Une vraie équipe qui décroche. Nous sommes là quand c'est le plus chargé et quand cela compte le plus.",
      },
    ],
  },
  offer: {
    heading: "Gratuit jusqu'au dernier jour de Gloriafood.",
    text: "Passez maintenant et ne payez rien jusqu'au 1er mai 2027. Votre abonnement ne démarre qu'au moment où Gloriafood s'arrête, pas avant.",
    button: 'Réclamer ma période gratuite',
    note: "* L'offre s'applique à l'abonnement standard Bistroo Webshop, pour les restaurants qui migrent depuis Gloriafood avant le 30 avril 2027.",
  },
  steps: {
    kicker: 'En 3 étapes',
    heading: 'En ligne en moins de 30 minutes',
    items: [
      {
        title: 'Créez votre compte gratuit',
        text: 'Inscrivez-vous sur merchant.bistroo.nl. Sans carte de crédit ni engagement. Fait en 2 minutes.',
      },
      {
        title: 'Configurez votre menu et votre boutique',
        text: 'Saisissez votre menu, choisissez un modèle et réglez votre domaine et vos horaires. Tout par vous-même, dans le Bistroo Manager.',
      },
      {
        title: 'Mettez en ligne et prenez des commandes',
        text: 'Connectez Stripe pour vos versements, publiez votre boutique et partagez votre lien ou votre QR code avec vos clients.',
      },
    ],
    button: 'Lancer ma boutique gratuite',
  },
  contact: {
    kicker: 'Parler à notre équipe',
    heading: 'Vous préférez une introduction personnelle ?',
    lead: "Laissez vos coordonnées et l'un de nos spécialistes restauration vous contacte dans un délai d'un jour ouvrable pour vous accompagner dans la migration. Sans frais.",
    perks: [
      'Nous vous aidons à reprendre votre menu depuis Gloriafood',
      'Aide gratuite pour la configuration du design de votre boutique',
      "Aucun frais d'abonnement jusqu'au 1er mai 2027",
      'Résiliable chaque mois, sans engagement à long terme',
    ],
    card: {
      title: 'Demandez votre migration',
      text: "Remplissez le formulaire de contact et nous vous répondons dans un délai d'un jour ouvrable. Vous préférez explorer par vous-même d'abord ? Créez directement votre compte gratuit.",
      button: 'Vers le formulaire de contact',
      secondary: 'Créer un compte gratuit',
      disclaimer: "Nous répondons dans un délai d'un jour ouvrable. Jamais de spam.",
    },
  },
  faq: {
    title_pt1: 'Questions fréquentes sur',
    title_pt2: 'la migration',
    items: [
      {
        q: 'Comment fonctionne exactement la période gratuite ?',
        a: "Inscrivez-vous avant le 30 avril 2027 et indiquez que vous migrez depuis Gloriafood. Nous activons votre compte sans frais d'abonnement jusqu'au 1er mai 2027. Ensuite, l'abonnement mensuel standard s'applique, résiliable chaque mois.",
      },
      {
        q: 'Puis-je reprendre mon menu depuis Gloriafood ?',
        a: 'Oui. Contactez notre équipe et nous vous aidons à le transférer. Vous préférez le faire vous-même ? Le générateur de menu du Bistroo Manager vous permet de créer rapidement vos catégories, options, photos et prix.',
      },
      {
        q: 'Faut-il des compétences techniques pour migrer ?',
        a: 'Non. Bistroo est entièrement en libre-service : le Bistroo Manager est conçu pour que vous, propriétaire de restaurant, configuriez et gériez tout vous-même, sans développeur. Si vous bloquez malgré tout, notre équipe support vous aide personnellement.',
      },
      {
        q: 'Que se passe-t-il après la période gratuite ?',
        a: "À partir du 1er mai 2027, vous passez à l'abonnement mensuel standard de Bistroo. Vous pouvez modifier ou résilier à tout moment ; nous ne travaillons pas avec des contrats à long terme.",
      },
      {
        q: 'Bistroo est-il disponible dans mon pays ?',
        a: 'Bistroo est disponible aux Pays-Bas et en Belgique, et nous lançons en Allemagne plus tard en 2026. Vous êtes ailleurs ? Contactez-nous et nous vous tiendrons informés de notre expansion.',
      },
    ],
  },
  cta: {
    heading_1: "N'attendez pas que les lumières s'éteignent.",
    heading_em: "Migrez aujourd'hui.",
    text: "30 minutes pour tout configurer. Gratuit jusqu'à l'arrêt de Gloriafood. Sans risque.",
    button_primary: 'Lancer ma boutique gratuite',
    button_secondary: 'Nous contacter',
  },
}
